import { request } from '@/utils/request'

export default {
    get(accessionNumber) {
        return request.get(`/api/providers/sec/filings/${accessionNumber}`)
    },
}
